import { render, staticRenderFns } from "./CompetencesPro.vue?vue&type=template&id=309938eb&"
import script from "./CompetencesPro.vue?vue&type=script&lang=js&"
export * from "./CompetencesPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports